export const apiConfig = {
  gql: {
    url: 'https://poc-api-capgemini.klefki.io.klefki.io/scooby-gql/',
  },
  rest: {
    url: 'https://poc-api-capgemini.klefki.io.klefki.io/scooby-iam',
  },
  sendOTPEP: '/user/sign-up',
  SignInUserEP: '/user/sign-in',
  accessTokenEP: '/user/access-token/get',
  baseURL: '',
  scriptURL: 'https://checkout.razorpay.com/v1/checkout.js',
  keyId: 'rzp_test_zMlQ6S29QkhjEK',
};
